import * as types from './types';
import createReducer from '../../createReducer';
import { FETCH_STATE } from 'constants';

const initialState = {
  current: {},
  list: [],
  fetchingTransaction: FETCH_STATE.UNSENT,
  fetchingCurrent: FETCH_STATE.UNSENT,
  pagination: {},
};

const paymentReducer = createReducer(initialState)({
  // Fetch Transaction List
  [types.FETCH_TRANSACTIONS_REQUEST]: (state) => {
    return {
      ...state,
      fetchingTransaction: FETCH_STATE.LOADING,
      list: [],
    };
  },
  [types.FETCH_TRANSACTIONS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingTransaction: FETCH_STATE.DONE,
      pagination: payload.pagination,
      list: payload.data,
    };
  },
  [types.FETCH_TRANSACTIONS_FAILED]: (state) => {
    return {
      ...state,
      fetchingTransaction: FETCH_STATE.ERROR,
    };
  },

  // Fetch Transaction By ID
  [types.FETCH_TRANSACTIONS_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      fetchingCurrent: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_TRANSACTIONS_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingCurrent: FETCH_STATE.DONE,
      current: payload,
    };
  },
  [types.FETCH_TRANSACTIONS_BY_ID_FAILED]: (state) => {
    return {
      ...state,
      fetchingCurrent: FETCH_STATE.ERROR,
    };
  },
});

export default paymentReducer;
